import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Input,
  Select,
  Text,
  Tbody,
  Tr,
  Td,
  Th,
  Thead,
  Card,
  Table,
  Tooltip,
  TableContainer,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useFormikContext } from "formik";
import * as Yup from "yup";
import { addFarm, addFarmer, getGeoCodes, getSuggestions } from "../../api";
import { useNavigate } from "react-router-dom";
import { statesList } from "../../Common/utils";
import isAllowed from "../../routing/isAllowed";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { Loader, RemoveIcon } from "../../assets/svgs/Icons";
import { toast } from "react-toastify";
import axios from "axios";
import { Spinner } from "@chakra-ui/react";
import Geocode from "react-geocode";
import { v4 as uuidv4 } from "uuid";
import dompurify from "dompurify";

function AddFarmer() {
  const [farms, setFarms] = useState([]);
  const [farmer, setFarmer] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const [farmerAddress, setFarmerAddress] = useState("");
  const [farmAddress, setFarmAddress] = useState("");
  const [coordinates, setCoordinates] = useState({});
  const [farmCoordinates, setFarmCoordinates] = useState({});
  const [suggestions, setSuggestions] = useState([]);
  const [farmLoading, setFarmLoading] = useState(false);
  const [openSuggestions, setOpenSuggestions] = useState(false);
  const [openFarmSuggestions, setOpenFarmSuggestions] = useState(false);
  const [idProof, setIdProof] = useState("");
  const [errorsCustom, setErrorsCustom] = useState({
    idProof: false,
    firstName: false,
    lastName: false,
    landSize: false,
    cultivation: false,
    farmerState: false,
    address: false,
    state: false,
    city: false, 
    pinCode: false, 
  });
  const [idProofExists, setIdProofExists] = useState(false);

  const handleGoBack = () => {
    navigate(-1);
  };

  const addToItems = async (
    values,
    farmerValues,
    farmerResponse,
    handleChange
  ) => {
    if (
      !values.landSize ||
      !values.cultivationCapacity ||
      !values.farmRawAddress ||
      !values.farmState
    ) {
      setErrorsCustom({
        landSize: !values.landSize ? true : false,
        cultivation: !values.cultivationCapacity ? true : false,
        address: !values.farmRawAddress ? true : false,
        state: !values.farmState ? true : false,
      });
      return toast.error("Please fill all the required farm detail fields");
    }
    setFarmLoading(true);
    let farmsValues = {
      farmId: uuidv4(),
      address: {
        location: {
          coordinates: [
            farmCoordinates?.lat ? farmCoordinates?.lat : null,
            farmCoordinates?.lng ? farmCoordinates?.lng : null,
          ],
        },
        district: dompurify.sanitize(values.farmDistrict),
        city: dompurify.sanitize(values.farmCity),
        state: dompurify.sanitize(values.farmState),
        country: dompurify.sanitize(values.farmCountry),
        pinCode: dompurify.sanitize(values.farmPinCode),
        raw_address: dompurify.sanitize(values.farmRawAddress),
      },
      cultivationCapacity: values.cultivationCapacity,
      landSize: values.landSize,
    };
    setFarms((prevFarms) => [farmsValues, ...prevFarms]);
    toast.success("Farm added successfully");
    setFarmLoading(false);
    setFarmCoordinates([]);
    handleChange({
      target: {
        id: "landSize",
        value: "",
      },
    });
    handleChange({
      target: {
        id: "cultivationCapacity",
        value: "",
      },
    });
    handleChange({
      target: {
        id: "farmRawAddress",
        value: "",
      },
    });
    handleChange({
      target: {
        id: "farmDistrict",
        value: "",
      },
    });
    handleChange({
      target: {
        id: "farmState",
        value: "",
      },
    });
    handleChange({
      target: {
        id: "farmCountry",
        value: "",
      },
    });
    handleChange({
      target: {
        id: "farmCity",
        value: "",
      },
    });
    handleChange({
      target: {
        id: "farmPinCode",
        value: "",
      },
    });
    handleChange({
      target: {
        id: "Latitude",
        value: "",
      },
    });
    handleChange({
      target: {
        id: "longitude",
        value: "",
      },
    });
  };

  const removeFarms = (id) => {
    setFarms((prev) => prev.filter((farm) => farm.farmId !== id));
    toast.success("Farm removed successfully");
  };

  const getData = async () => {
    const token = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/farmer/${idProof}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (data?.data !== null) {
        setFarmer(data?.data);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  // check if the ID already exists in system
  useEffect(() => {
    const token = localStorage.getItem("cu_user");

    const checkIDExistsInIntervals = setTimeout(() => {
      const checkIDExists = async () => {
        setIsChecking(true);
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_HOST}/api/farmer/check-existence/${idProof}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setIdProofExists(data?.exists);

        //autofill farmer details
        if (data?.exists === true) {
          getData();
        } else {
          setFarmer({
            firstName: "",
            lastName: "",
            idProof: idProof,
            contactInfo: {
              phone: "",
              email: "",
            },
            address: {
              location: {
                type: "Point",
                coordinates: [],
              },
              state: "",
              pinCode: "",
              city: "",
              raw_address: "",
            },
          });
        }

        setIsChecking(false);
      };

      if (idProof > 0) {
        checkIDExists();
      }
    }, 500);

    return () => {
      clearTimeout(checkIDExistsInIntervals);
    };
  }, [idProof, idProofExists]);

  const setGeoCode = async (address) => {
    const response = await getGeoCodes(address);
    setCoordinates(response?.data?.location);
  };

  const setFarmGeoCode = async (address) => {
    const response = await getGeoCodes(address);
    setFarmCoordinates(response?.data?.location);
  };

  const getSetSuggestions = async (address) => {
    const response = await getSuggestions(address);
    setSuggestions(response?.data?.predictions);
  };

  const getFarmSuggestions = async (address) => {
    const response = await getSuggestions(address);
    setSuggestions(response?.data?.predictions);
  };

  const handleIdProofCheck = (e) => {
    setIdProof(e.target.value);
  };

  useEffect(() => {
    if (farmAddress) {
      setFarmGeoCode(farmAddress);
      getFarmSuggestions(farmAddress);
    }
  }, [farmAddress]);

  return (
    <Box marginBottom={"2rem"}>
      <Box
        display={"flex"}
        alignItems="center"
        cursor={"pointer"}
        onClick={handleGoBack}
      >
        <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
        &nbsp;
        <Text
          //#3958DC
          color={"#52BBFF"}
          fontSize={{ base: "sm", md: "sm", lg: "md" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Go Back
        </Text>
      </Box>
      <Box marginTop="2rem">
        <Text
          color={"#141D43"}
          fontSize="2xl"
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Farmer Form
        </Text>
        <Text color={" #3958DC"} fontSize="sm">
          Register Farmer Details
        </Text>
      </Box>
      <Box
        marginTop={"1.5rem"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft="-2rem"
        marginRight={"-2.5rem"}
        bg="linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
        borderTopRightRadius="100px"
        borderBottomRightRadius="80px 80px"
      >
        Register Farmer / Farmer Details
      </Box>
      <Formik
        initialValues={{
          firstName: "",
          lastName: "",
          email: "",
          idProof: "",
          contactNumber: "",
          pinCode: "",
          address: "",
          city: "",
          state: "",
          landSize: "",
          cultivationCapacity: "",
          Latitude: "",
          longitude: "",
          farmDistrict: "",
          farmCity: "",
          farmState: "",
          farmCountry: "",
          farmPinCode: "",
          farmRawAddress: "",
        }}
        onSubmit={async (values, { resetForm }) => {
          if (idProofExists) {
            setIsloading(true);
            let farmerResponse = await addFarmer(farmer);
            if (farmerResponse?.data?.status === "success") {
              navigate("/supplier");
              setIsloading(false);
            }
          } else {
            if (
              !idProof ||
              !values.firstName ||
              !values.lastName ||
              !values.state || !values.address || !values.pinCode || !values.city
            ) {
              setErrorsCustom({
                idProof: !idProof ? true : false,
                firstName: !values.firstName ? true : false,
                lastName: !values.lastName ? true : false,
                farmerState: !values.state ? true : false,
                pinCode: !values.pinCode ? true : false, 
                address: !values.address ? true : false, 
                city: !values?.city ? true : false
              });
              return toast.error("Please fill all the required fields");
            }
            setIsloading(true);
            let farmerValues = {
              firstName: dompurify.sanitize(values.firstName),
              lastName: dompurify.sanitize(values.lastName),
              idProof: values.idProof || idProof,
              contactInfo: {
                phone: values.contactNumber,
                email: dompurify.sanitize(values.email),
              },
              address: {
                location: {
                  type: "Point",
                  coordinates: [
                    coordinates?.lat ? coordinates?.lat : null,
                    coordinates?.lng ? coordinates?.lng : null,
                  ],
                },
                state: dompurify.sanitize(values.state),
                pinCode: values.pinCode,
                city: dompurify.sanitize(values.city),
                raw_address: dompurify.sanitize(values.address),
              },
            };

            let farmerResponse = await addFarmer(farmerValues, setIsloading);
            let newfarms;
            if (farmerResponse) {
              newfarms = farms.map((el) => {
                return {
                  ...el,
                  ownerId: farmerResponse?.data?.data[0]?._id,
                };
              });
            }

            let farmResponse = await addFarm(newfarms, resetForm);

            if (farmerResponse?.data?.status === "success") {
              navigate("/supplier");
              setIsloading(false);
            }
          }
        }}
        validationSchema={Yup.object().shape({})}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            farmerValues,
            handleSubmit,
            farmerResponse,
            resetForm,
          } = props;
          return (
            <form>
              <Box>
                <Box
                  bg="white"
                  p={"1rem"}
                  mt="2rem"
                  borderRadius="15px"
                  boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
                >
                  <Box p="1rem">
                    <Grid templateColumns="repeat(2, 1.5fr)" marginTop={"1rem"}>
                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Aadhar Number / Any ID Proof &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>

                        <Input
                          type="number"
                          onWheel={() => document.activeElement.blur()}
                          color={"#141D43"}
                          marginTop="10px"
                          border="2px solid  #8fd0fd !important"
                          w="100%"
                          bg={"#fff"}
                          id="idProof"
                          value={idProof}
                          _focusVisible={
                            errorsCustom.idProof
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          onChange={(e) => {
                            handleIdProofCheck(e);
                            setErrorsCustom((prev) => ({
                              ...prev,
                              idProof: false,
                            }));
                          }}
                          onBlur={handleBlur}
                          placeholder=""
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                      </GridItem>
                      <GridItem>
                        {isChecking ? (
                          <>
                            <Spinner
                              size="sm"
                              marginTop={"2.5rem"}
                              marginLeft={"1rem"}
                            />
                          </>
                        ) : (
                          <></>
                        )}

                        {idProofExists && !isChecking && (
                          <Text
                            marginTop={"2.5rem"}
                            fontSize={"12px"}
                            color={"brand.alertRed"}
                            marginLeft={"1rem"}
                          >
                            {"This Farmer ID Already registered."}
                          </Text>
                        )}
                      </GridItem>
                      {errorsCustom.idProof && (
                        <Box color="red.500">
                          Aadhar number / id proof is required
                        </Box>
                      )}
                    </Grid>
                  </Box>

                  <Box p="1rem">
                    <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
                      <GridItem colSpan={1}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          First Name &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Input
                          type="text"
                          color={"#141D43"}
                          marginTop="10px"
                          w="80%"
                          bg={"#fff"}
                          id="firstName"
                          border="2px solid  #8fd0fd !important"
                          placeholder=""
                          value={values.firstName || farmer?.firstName}
                          onChange={(e) => {
                            handleChange(e);
                            setErrorsCustom((prev) => ({
                              ...prev,
                              firstName: false,
                            }));
                          }}
                          disabled={farmer?.firstName ? true : ""}
                          opacity={"1 !important"}
                          onBlur={handleBlur}
                          fontSize={"14px"}
                          _focusVisible={
                            !farmer?.firstName && errorsCustom.firstName
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                        {!farmer?.firstName
                          ? errorsCustom.firstName && (
                              <Box color="red.500">First Name is required</Box>
                            )
                          : ""}
                      </GridItem>
                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Last Name &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Input
                          type="text"
                          color={"#141D43"}
                          marginTop="10px"
                          w="80%"
                          id="lastName"
                          bg={"#fff"}
                          placeholder=""
                          disabled={farmer?.lastName ? true : ""}
                          opacity={"1 !important"}
                          border="2px solid  #8fd0fd !important"
                          value={values.lastName || farmer?.lastName}
                          onChange={(e) => {
                            handleChange(e);
                            setErrorsCustom((prev) => ({
                              ...prev,
                              lastName: false,
                            }));
                          }}
                          onBlur={handleBlur}
                          _focusVisible={
                            !farmer?.lastName && errorsCustom.lastName
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                        {!farmer?.lastName
                          ? errorsCustom.lastName && (
                              <Box color="red.500">Last Name is required</Box>
                            )
                          : ""}
                      </GridItem>
                    </Grid>
                  </Box>
                  <Box p="1rem">
                    <Grid marginTop={"1rem"}>
                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Email
                        </Text>
                        <Input
                          type="email"
                          color={"#141D43"}
                          marginTop="10px"
                          w="60%"
                          id="email"
                          opacity={"1 !important"}
                          border="2px solid  #8fd0fd !important"
                          bg={"#fff"}
                          value={values.email || farmer?.contactInfo?.email}
                          disabled={farmer?.contactInfo?.email ? true : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder=""
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                      </GridItem>
                    </Grid>
                  </Box>

                  <Box p="1rem">
                    <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
                      <GridItem colSpan={1}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Contact Number
                        </Text>
                        <Input
                          type="tel"
                          onWheel={() => document.activeElement.blur()}
                          color={"#141D43"}
                          marginTop="10px"
                          w="80%"
                          bg={"#fff"}
                          border="2px solid  #8fd0fd !important"
                          id="contactNumber"
                          placeholder=""
                          value={
                            values.contactNumber || farmer?.contactInfo?.phone
                          }
                          opacity={"1 !important"}
                          disabled={farmer?.contactInfo?.phone ? true : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                      </GridItem>
                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Pincode
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Input
                          type="tel"
                          onWheel={() => document.activeElement.blur()}
                          color={"#141D43"}
                          marginTop="10px"
                          w="80%"
                          bg={"#fff"}
                          id="pinCode"
                          opacity={"1 !important"}
                          border="2px solid  #8fd0fd !important"
                          value={values.pinCode || farmer?.address?.pinCode}
                          disabled={farmer?.address?.pinCode ? true : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder=""
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                                                  {errorsCustom?.pinCode && (
                              <Box color="red.500">Pincode is required</Box>
                            )
                          }
                      </GridItem>
                    </Grid>
                  </Box>
                  <Box p="1rem">
                    <Grid marginTop={"1rem"}>
                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Address
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Input
                          autoComplete="off"
                          type="tel"
                          color={"#141D43"}
                          marginTop="10px"
                          bg={"#fff"}
                          w="60%"
                          id="address"
                          opacity={"1 !important"}
                          border="2px solid  #8fd0fd !important"
                          value={values.address || farmer?.address?.raw_address}
                          disabled={farmer?.address?.raw_address ? true : ""}
                          onChange={(e) => {
                            handleChange(e);
                            getSetSuggestions(e.target.value);
                          }}
                          onFocus={() => setOpenSuggestions(true)}
                          onBlur={(e) => {
                            handleBlur(e);
                            setOpenSuggestions(false);
                          }}
                          placeholder=""
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                        
                                                                       
                          {errorsCustom?.address && (
                              <Box color="red.500">Address is required</Box>
                            )
                          }
                        {openSuggestions ? (
                          <Box width={"90%"} marginTop={"10px"}>
                            <Card
                              boxShadow={
                                "rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"
                              }
                            >
                              <Box>
                                {suggestions
                                  ? suggestions?.map((suggestion) => (
                                      <Box
                                        mb={"1rem"}
                                        mt={"1rem"}
                                        ml={"2rem"}
                                        onMouseUp={() =>
                                          setOpenSuggestions(false)
                                        }
                                        onMouseDown={() => {
                                          handleChange({
                                            target: {
                                              id: "address",
                                              value: suggestion?.description,
                                            },
                                          });
                                          setGeoCode(suggestion?.description);
                                        }}
                                        _hover={{
                                          background:
                                            "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 35%, rgba(164,206,255,1) 100%);",
                                          cursor: "pointer",
                                          color: "#fff",
                                          pl: "10px",
                                        }}
                                      >
                                        {suggestion?.description}
                                      </Box>
                                    ))
                                  : "No Results Found"}
                              </Box>
                            </Card>
                          </Box>
                        ) : (
                          ""
                        )}
                      </GridItem>
                    </Grid>
                  </Box>
                  <Box p="1rem">
                    <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
                      <GridItem colSpan={1}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          City
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Input
                          type="text"
                          color={"#141D43"}
                          marginTop="10px"
                          w="80%"
                          id="city"
                          bg={"#fff"}
                          opacity={"1 !important"}
                          border="2px solid  #8fd0fd !important"
                          value={values.city || farmer?.address?.city}
                          disabled={farmer?.address?.city ? true : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                                                  {errorsCustom?.city && (
                              <Box color="red.500">City is required</Box>
                            )
                          }
                      </GridItem>
                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          State &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Select
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                          placeholder=""
                          color={"#141D43"}
                          marginTop="10px"
                          w="80%"
                          id="state"
                          bg={"#fff"}
                          opacity={"1 !important"}
                          border="2px solid  #8fd0fd !important"
                          value={values.state || farmer?.address?.state}
                          _focusVisible={
                            !farmer?.address?.state && errorsCustom.farmerState
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          disabled={farmer?.address?.state ? true : ""}
                          onChange={(e) => {
                            handleChange(e);
                            setErrorsCustom((prev) => ({
                              ...prev,
                              farmerState: false,
                            }));
                          }}
                          onBlur={handleBlur}
                        >
                          <option hidden="true">Select Your State</option>
                          {statesList.map((state, index) => (
                            <option key={index}>{state}</option>
                          ))}
                        </Select>
                        {!farmer?.address?.state
                          ? errorsCustom.farmerState && (
                              <Box color="red.500">State is required</Box>
                            )
                          : ""}
                      </GridItem>
                    </Grid>
                  </Box>

                  <Box p="1rem">
                    <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
                      <GridItem colSpan={1}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Latitude
                        </Text>
                        <Input
                          type="text"
                          color={"#141D43"}
                          marginTop="10px"
                          w="80%"
                          id="city"
                          bg={"#fff"}
                          opacity={"1 !important"}
                          border="2px solid  #8fd0fd !important"
                          value={coordinates?.lat ? coordinates?.lat : "N/A"}
                          disabled={true}
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                      </GridItem>
                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Longitude
                        </Text>
                        <Input
                          type="text"
                          color={"#141D43"}
                          marginTop="10px"
                          w="80%"
                          id="city"
                          bg={"#fff"}
                          opacity={"1 !important"}
                          border="2px solid  #8fd0fd !important"
                          value={coordinates?.lng ? coordinates?.lng : "N/A"}
                          disabled={true}
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                        />
                      </GridItem>
                    </Grid>
                  </Box>
                </Box>

                <>
                  {/* if ID exists it fetches, old farm details */}
                  {idProofExists && (
                    <Box mt="1rem">
                      {farmer?.farmer_farm_details?.length > 0 && (
                        <>
                          <Box mt="1rem" mb="1rem">
                            <Text
                              color={"#141D43"}
                              fontSize="md"
                              fontWeight={"800"}
                              fontFamily={"font.roboto"}
                            >
                              Previously Added Farms
                            </Text>
                          </Box>

                          <TableContainer className="overflow-style">
                            <Table
                              variant={"simple"}
                              size="md"
                              bg={"#fff"}
                              borderRadius={"15px"}
                              pr={"1rem"}
                            >
                              <Thead>
                                <Tr>
                                  <Th
                                    color="brand.blue"
                                    textTransform="capitalize"
                                  >
                                    Sr no.
                                  </Th>
                                  <Th
                                    color="brand.blue"
                                    textTransform="capitalize"
                                  >
                                    LandSize
                                  </Th>
                                  <Th
                                    color="brand.blue"
                                    textTransform="capitalize"
                                  >
                                    Cultivation Capacity
                                  </Th>

                                  <Th
                                    color="brand.blue"
                                    textTransform="capitalize"
                                  >
                                    Address
                                  </Th>
                                  <Th
                                    color="brand.blue"
                                    textTransform="capitalize"
                                  >
                                    District
                                  </Th>
                                  <Th
                                    color="brand.blue"
                                    textTransform="capitalize"
                                  >
                                    City
                                  </Th>
                                  <Th
                                    color="brand.blue"
                                    textTransform="capitalize"
                                  >
                                    State
                                  </Th>
                                  <Th
                                    color="brand.blue"
                                    textTransform="capitalize"
                                  >
                                    Country
                                  </Th>
                                  <Th
                                    color="brand.blue"
                                    textTransform="capitalize"
                                  >
                                    Pin Code
                                  </Th>

                                  <Th
                                    color="brand.blue"
                                    textTransform="capitalize"
                                  >
                                    Latitude
                                  </Th>
                                  <Th
                                    color="brand.blue"
                                    textTransform="capitalize"
                                  >
                                    Longitude
                                  </Th>

                                  {/* <Th color="brand.blue" textTransform="capitalize">
                                      Action
                                    </Th> */}
                                </Tr>
                              </Thead>
                              <Tbody>
                                {farmer?.farmer_farm_details?.map(
                                  (data, index) => {
                                    return (
                                      <Tr>
                                        <Td>{index + 1}</Td>
                                        <Td>
                                          {data?.landSize
                                            ? data?.landSize
                                            : "N/A"}
                                        </Td>
                                        <Td>
                                          {data?.cultivationCapacity
                                            ? data?.cultivationCapacity
                                            : "N/A"}
                                        </Td>

                                        <Td>
                                          <Tooltip
                                            label={data?.address?.raw_address}
                                          >
                                            <Text
                                              maxWidth="50px"
                                              overflow="hidden"
                                              textOverflow="ellipsis"
                                            >
                                              {data?.address?.raw_address
                                                ? data?.address?.raw_address
                                                : "N/A"}
                                            </Text>
                                          </Tooltip>
                                        </Td>
                                        <Td>
                                          {data?.address?.district
                                            ? data?.address?.district
                                            : "N/A"}
                                        </Td>
                                        <Td>
                                          {data?.address?.city
                                            ? data?.address?.city
                                            : "N/A"}
                                        </Td>
                                        <Td>
                                          {data?.address?.state
                                            ? data?.address?.state
                                            : "N/A"}
                                        </Td>
                                        <Td>
                                          {data?.address?.country
                                            ? data?.address?.country
                                            : "N/A"}
                                        </Td>
                                        <Td>
                                          {data?.address?.pinCode
                                            ? data?.address?.pinCode
                                            : "N/A"}
                                        </Td>

                                        <Td>
                                          {data?.address?.location
                                            ?.coordinates[0]
                                            ? data?.address?.location
                                                ?.coordinates[0]
                                            : "N/A"}
                                        </Td>
                                        <Td>
                                          {data?.address?.location
                                            ?.coordinates[1]
                                            ? data?.address?.location
                                                ?.coordinates[1]
                                            : "N/A"}
                                        </Td>
                                        {/* <Td>
                                          <Box
                                            cursor="pointer"
                                            onClick={() => removeFarms(data.id)}
                                          >
                                            <RemoveIcon />
                                          </Box>
                                        </Td> */}
                                      </Tr>
                                    );
                                  }
                                )}
                              </Tbody>
                            </Table>
                          </TableContainer>
                        </>
                      )}
                    </Box>
                  )}

                  {!idProofExists && (
                    <>
                      <Box
                        marginTop={"1.5rem"}
                        color={"#fff"}
                        padding={"10px 2rem"}
                        fontWeight="700"
                        marginLeft="-2rem"
                        marginRight={"-2.5rem"}
                        bg="linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
                        borderTopRightRadius="100px"
                        borderBottomRightRadius="80px 80px"
                      >
                        Farm Details
                      </Box>
                      <Box
                        bg="white"
                        p={"1rem"}
                        mt="2rem"
                        borderRadius="15px"
                        boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
                      >
                        <Box p="1rem">
                          <Grid
                            templateColumns="repeat(3, 1fr)"
                            marginTop={"1rem"}
                          >
                            <GridItem colSpan={1}>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Land Size (Acres) &nbsp;
                                <Text as="span" color="red">
                                  *
                                </Text>
                              </Text>
                              <Input
                                type="number"
                                color={"#141D43"}
                                marginTop="10px"
                                bg={"#fff"}
                                w="60%"
                                id="landSize"
                                border="2px solid  #8fd0fd !important"
                                placeholder=""
                                value={values.landSize}
                                _focusVisible={
                                  errorsCustom.landSize
                                    ? {
                                        border: "1px solid red !important",
                                      }
                                    : { border: "1px solid #464C64" }
                                }
                                onChange={(e) => {
                                  handleChange(e);
                                  setErrorsCustom((prev) => ({
                                    ...prev,
                                    landSize: false,
                                  }));
                                }}
                                onBlur={handleBlur}
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                              />
                              {errorsCustom.landSize && (
                                <Box color="red.500">Land size is required</Box>
                              )}
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Cultivation Capacity (kg) &nbsp;
                                <Text as="span" color="red">
                                  *
                                </Text>
                              </Text>
                              <Input
                                type="number"
                                onWheel={() => document.activeElement.blur()}
                                color={"#141D43"}
                                marginTop="10px"
                                bg={"#fff"}
                                w="60%"
                                border="2px solid  #8fd0fd !important"
                                id="cultivationCapacity"
                                _focusVisible={
                                  errorsCustom.cultivation
                                    ? {
                                        border: "1px solid red !important",
                                      }
                                    : { border: "1px solid #464C64" }
                                }
                                value={values.cultivationCapacity}
                                onChange={(e) => {
                                  handleChange(e);
                                  setErrorsCustom((prev) => ({
                                    ...prev,
                                    cultivation: false,
                                  }));
                                }}
                                onBlur={handleBlur}
                                placeholder=""
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                              />
                              {errorsCustom.cultivation && (
                                <Box color="red.500">
                                  Cultivation capacity is required
                                </Box>
                              )}
                            </GridItem>
                          </Grid>
                        </Box>
                        <Box p="1rem">
                          <Grid marginTop={"1rem"}>
                            <GridItem colSpan={3}>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Address &nbsp;
                                <Text as="span" color="red">
                                  *
                                </Text>
                              </Text>
                              <Input
                                type="text"
                                autoComplete="off"
                                color={"#141D43"}
                                marginTop="10px"
                                bg={"#fff"}
                                w="53%"
                                border="2px solid  #8fd0fd !important"
                                id="farmRawAddress"
                                placeholder=""
                                value={values.farmRawAddress}
                                _focusVisible={
                                  errorsCustom.address
                                    ? {
                                        border: "1px solid red !important",
                                      }
                                    : { border: "1px solid #464C64" }
                                }
                                onChange={(e) => {
                                  handleChange(e);
                                  setErrorsCustom((prev) => ({
                                    ...prev,
                                    address: false,
                                  }));
                                  getFarmSuggestions(e.target.value);
                                }}
                                onFocus={() => setOpenFarmSuggestions(true)}
                                onBlur={(e) => {
                                  handleBlur(e);
                                  setOpenFarmSuggestions(false);
                                }}
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                              />
                              {errorsCustom.address && (
                                <Box color="red.500">Address is required</Box>
                              )}
                            </GridItem>
                            {openFarmSuggestions ? (
                              <Box width={"95%"} marginTop={"10px"}>
                                <Card
                                  boxShadow={
                                    "rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"
                                  }
                                >
                                  <Box>
                                    {suggestions
                                      ? suggestions?.map((suggestion) => (
                                          <Box
                                            mb={"1rem"}
                                            mt={"1rem"}
                                            ml={"2rem"}
                                            onMouseUp={() =>
                                              setOpenFarmSuggestions(false)
                                            }
                                            onMouseDown={() => {
                                              handleChange({
                                                target: {
                                                  id: "farmRawAddress",
                                                  value:
                                                    suggestion?.description,
                                                },
                                              });

                                              setFarmGeoCode(
                                                suggestion?.description
                                              );
                                            }}
                                            _hover={{
                                              background:
                                                "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 35%, rgba(164,206,255,1) 100%);",
                                              cursor: "pointer",
                                              color: "#fff",
                                              pl: "10px",
                                            }}
                                          >
                                            {suggestion?.description}
                                          </Box>
                                        ))
                                      : "No results found"}
                                  </Box>
                                </Card>
                              </Box>
                            ) : (
                              ""
                            )}
                          </Grid>
                        </Box>
                        <Box p="1rem">
                          <Grid marginTop={"1rem"}>
                            <GridItem colSpan={3}>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                District
                              </Text>
                              <Input
                                type="text"
                                border="2px solid  #8fd0fd !important"
                                onWheel={() => document.activeElement.blur()}
                                color={"#141D43"}
                                marginTop="10px"
                                bg={"#fff"}
                                w="53%"
                                id="farmDistrict"
                                value={values.farmDistrict}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder=""
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                          </Grid>
                        </Box>

                        <Box p="1rem">
                          <Grid
                            templateColumns="repeat(3, 1fr)"
                            marginTop={"1rem"}
                          >
                            <GridItem colSpan={1}>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                City
                              </Text>
                              <Input
                                type="text"
                                color={"#141D43"}
                                marginTop="10px"
                                bg={"#fff"}
                                w="60%"
                                id="farmCity"
                                border="2px solid  #8fd0fd !important"
                                placeholder=""
                                value={values.farmCity}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                State &nbsp;
                                <Text as="span" color="red">
                                  *
                                </Text>
                              </Text>

                              <Select
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                                placeholder=""
                                color={"#141D43"}
                                marginTop="10px"
                                w="60%"
                                id="farmState"
                                border="2px solid  #8fd0fd !important"
                                bg={"#fff"}
                                value={values.farmState}
                                _focusVisible={
                                  errorsCustom.state
                                    ? {
                                        border: "1px solid red !important",
                                      }
                                    : { border: "1px solid #464C64" }
                                }
                                onChange={(e) => {
                                  handleChange(e);
                                  setErrorsCustom((prev) => ({
                                    ...prev,
                                    state: false,
                                  }));
                                }}
                                onBlur={handleBlur}
                              >
                                <option hidden="true">Select Your State</option>
                                {statesList.map((state, index) => (
                                  <option key={index}>{state}</option>
                                ))}
                              </Select>
                              {errorsCustom.address && (
                                <Box color="red.500">State is required</Box>
                              )}
                            </GridItem>
                          </Grid>
                        </Box>

                        <Box p="1rem">
                          <Grid
                            templateColumns="repeat(3, 1fr)"
                            marginTop={"1rem"}
                          >
                            <GridItem colSpan={1}>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Country
                              </Text>
                              <Input
                                type="text"
                                color={"#141D43"}
                                marginTop="10px"
                                bg={"#fff"}
                                w="60%"
                                id="farmCountry"
                                border="2px solid  #8fd0fd !important"
                                placeholder=""
                                value={values.farmCountry}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Pincode
                              </Text>
                              <Input
                                type="number"
                                color={"#141D43"}
                                marginTop="10px"
                                bg={"#fff"}
                                w="60%"
                                id="farmPinCode"
                                border="2px solid  #8fd0fd !important"
                                placeholder=""
                                value={values.farmPinCode}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                          </Grid>
                        </Box>

                        <Box p="1rem">
                          <Grid
                            templateColumns="repeat(3, 1fr)"
                            marginTop={"1rem"}
                          >
                            <GridItem colSpan={1}>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Latitude
                              </Text>
                              <Input
                                type="number"
                                onWheel={() => document.activeElement.blur()}
                                color={"#141D43"}
                                marginTop="10px"
                                id="Latitude"
                                bg={"#fff"}
                                w="60%"
                                disabled="true"
                                opacity={"1 !important"}
                                value={
                                  farmCoordinates?.lat
                                    ? farmCoordinates?.lat
                                    : "N/A"
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder=""
                                border="2px solid  #8fd0fd !important"
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Longitude
                              </Text>
                              <Input
                                type="number"
                                onWheel={() => document.activeElement.blur()}
                                color={"#141D43"}
                                marginTop="10px"
                                bg={"#fff"}
                                w="60%"
                                id="longitude"
                                border="2px solid  #8fd0fd !important"
                                disabled="true"
                                opacity={"1 !important"}
                                value={
                                  farmCoordinates?.lng
                                    ? farmCoordinates?.lng
                                    : "N/A"
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder=""
                                fontSize={"14px"}
                                _placeholder={{
                                  opacity: 1,
                                  color: " #464C64",
                                  fontSize: "14px",
                                }}
                              />
                            </GridItem>
                          </Grid>
                          <Button
                            w="100px"
                            mt="2rem"
                            disabled={farmLoading ? true : ""}
                            onClick={() =>
                              farmLoading
                                ? ""
                                : addToItems(
                                    values,
                                    farmerValues,
                                    farmerResponse,
                                    handleChange
                                  )
                            }
                            bg="#52BBFF"
                            color={"#fff"}
                            _hover={{ bg: "#52BBFF" }}
                          >
                            {farmLoading ? (
                              <Loader width="25px" height="25px" />
                            ) : (
                              "Add Farm"
                            )}
                          </Button>

                          {/* farm array values mapping */}
                          <Box mt="1rem">
                            {farms?.length > 0 ? (
                              <TableContainer className="overflow-style">
                                <Table
                                  variant={"simple"}
                                  size="md"
                                  bg={"#fff"}
                                  borderRadius={"15px"}
                                  pr={"1rem"}
                                >
                                  <Thead>
                                    <Tr>
                                      <Th
                                        color="brand.blue"
                                        textTransform="capitalize"
                                      >
                                        Sr no.
                                      </Th>
                                      <Th
                                        color="brand.blue"
                                        textTransform="capitalize"
                                      >
                                        LandSize
                                      </Th>
                                      <Th
                                        color="brand.blue"
                                        textTransform="capitalize"
                                      >
                                        Cultivation Capacity
                                      </Th>

                                      <Th
                                        color="brand.blue"
                                        textTransform="capitalize"
                                      >
                                        Address
                                      </Th>
                                      <Th
                                        color="brand.blue"
                                        textTransform="capitalize"
                                      >
                                        District
                                      </Th>
                                      <Th
                                        color="brand.blue"
                                        textTransform="capitalize"
                                      >
                                        City
                                      </Th>
                                      <Th
                                        color="brand.blue"
                                        textTransform="capitalize"
                                      >
                                        State
                                      </Th>
                                      <Th
                                        color="brand.blue"
                                        textTransform="capitalize"
                                      >
                                        Country
                                      </Th>
                                      <Th
                                        color="brand.blue"
                                        textTransform="capitalize"
                                      >
                                        Pin Code
                                      </Th>

                                      <Th
                                        color="brand.blue"
                                        textTransform="capitalize"
                                      >
                                        Latitude
                                      </Th>
                                      <Th
                                        color="brand.blue"
                                        textTransform="capitalize"
                                      >
                                        Longitude
                                      </Th>

                                      <Th
                                        color="brand.blue"
                                        textTransform="capitalize"
                                      >
                                        Action
                                      </Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {farms?.map((data, index) => {
                                      return (
                                        <Tr>
                                          <Td>{index + 1}</Td>
                                          <Td>
                                            {data?.landSize
                                              ? data?.landSize
                                              : "N/A"}
                                          </Td>
                                          <Td>
                                            {data?.cultivationCapacity
                                              ? data?.cultivationCapacity
                                              : "N/A"}
                                          </Td>

                                          <Td>
                                            <Tooltip
                                              label={data?.address?.raw_address}
                                            >
                                              <Text
                                                maxWidth="50px"
                                                overflow="hidden"
                                                textOverflow="ellipsis"
                                              >
                                                {data?.address?.raw_address
                                                  ? data?.address?.raw_address
                                                  : "N/A"}
                                              </Text>
                                            </Tooltip>
                                          </Td>
                                          <Td>
                                            {data?.address?.district
                                              ? data?.address?.district
                                              : "N/A"}
                                          </Td>
                                          <Td>
                                            {data?.address?.city
                                              ? data?.address?.city
                                              : "N/A"}
                                          </Td>
                                          <Td>
                                            {data?.address?.state
                                              ? data?.address?.state
                                              : "N/A"}
                                          </Td>
                                          <Td>
                                            {data?.address?.country
                                              ? data?.address?.country
                                              : "N/A"}
                                          </Td>
                                          <Td>
                                            {data?.address?.pinCode
                                              ? data?.address?.pinCode
                                              : "N/A"}
                                          </Td>

                                          <Td>
                                            {data?.address?.location
                                              ?.coordinates[0]
                                              ? data?.address?.location
                                                  ?.coordinates[0]
                                              : "N/A"}
                                          </Td>
                                          <Td>
                                            {data?.address?.location
                                              ?.coordinates[1]
                                              ? data?.address?.location
                                                  ?.coordinates[1]
                                              : "N/A"}
                                          </Td>
                                          <Td>
                                            <Box
                                              cursor="pointer"
                                              onClick={() =>
                                                removeFarms(data.farmId)
                                              }
                                            >
                                              <RemoveIcon />
                                            </Box>
                                          </Td>
                                        </Tr>
                                      );
                                    })}
                                  </Tbody>
                                </Table>
                              </TableContainer>
                            ) : (
                              <Box mt="1rem" mb="1rem">
                                <Text
                                  color={"#141D43"}
                                  fontSize="md"
                                  fontWeight={"800"}
                                  fontFamily={"font.roboto"}
                                >
                                  Added farm details will appear here
                                </Text>
                                <Box
                                  border={"2px solid #2272D5"}
                                  width="10%"
                                  marginBottom={"1rem"}
                                ></Box>
                              </Box>
                            )}
                          </Box>
                          {/* farm array values mapping */}
                        </Box>
                      </Box>
                    </>
                  )}

                  <Box
                    marginTop={"2rem"}
                    bg="white"
                    p={"1rem"}
                    mt="2rem"
                    mb="1rem"
                    borderRadius="15px"
                    boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
                  >
                    <Box p={"1rem"}>
                      {idProofExists ? (
                        ""
                      ) : (
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"800"}
                          marginBottom={"10px"}
                          fontFamily={"font.roboto"}
                        >
                          Click the button below to add farmer
                        </Text>
                      )}
                      <Button
                        disabled={isLoading ? "true" : ""}
                        bg="#52BBFF"
                        mt="1rem"
                        color={"#fff"}
                        _hover={{ bg: "#52BBFF" }}
                        onClick={() => (isLoading ? "" : handleSubmit(values))}
                      >
                        {isLoading ? (
                          <Loader width="25px" height="25px" />
                        ) : idProofExists ? (
                          "Associate Farmer with You"
                        ) : (
                          "Submit Form"
                        )}
                      </Button>
                    </Box>
                  </Box>
                </>
              </Box>
            </form>
          );
        }}
      </Formik>
    </Box>
  );
}

export default isAllowed(AddFarmer);
